import type { RoundDataLayout } from "@moment-golf/types";

export const roundDataLayout = [
    {
        section: "Round Details",
        field: "roundNumber",
        label: "Round Number",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: true,
    },
    {
        section: "Round Details",
        field: "courseName",
        label: "Course Name",
        required: true,
        block: 0,
        blockName: "The Round",
        labelField: "courseName",
        optionsKeyName: "courses",
        locked: false,
    },
    {
        section: "Round Details",
        field: "totalHoles",
        label: "Total Holes",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: false,
    },
    {
        section: "Round Details",
        field: "startHole",
        label: "Starting hole",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: false,
    },
    {
        section: "Round Details",
        field: "playType",
        label: "Play Type",
        required: true,
        block: 0,
        blockName: "The Round",
        labelField: "type",
        optionsKeyName: "PlayTypes",
        locked: false,
    },
    {
        section: "Round Details",
        field: "playFormat",
        label: "Play Format",
        required: true,
        block: 0,
        blockName: "The Round",
        labelField: "type",
        optionsKeyName: "PlayFormats",
        locked: false,
    },
    {
        section: "Round Details",
        field: "playerVersus",
        label: "Player Versus",
        required: true,
        block: 0,
        blockName: "The Round",
        labelField: "type",
        optionsKeyName: "PlayerVersus",
        locked: false,
    },
    {
        section: "Round Details",
        field: "scoreFormat",
        label: "Score Format",
        required: true,
        block: 0,
        labelField: "type",
        optionsKeyName: "ScoreFormat",
        blockName: "The Round",
    },
    {
        section: "Round Details",
        field: "regType",
        label: "Registration Type",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: true,
        eventLevel: true,
    },
    {
        section: "Round Details",
        field: "regQty",
        label: "Registration Qty",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: true,
        eventLevel: true,
    },
    {
        section: "Round Details",
        field: "usePoints",
        label: "Use Points?",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: false,
    },
    {
        section: "Round Details",
        field: "regPerTeeTime",
        label: "Registrations Per Slot",
        required: true,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "splitTees",
        label: "Split Tees?",
        required: true,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "shotgunStart",
        label: "Shotgun Start?",
        required: true,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "useBracket",
        label: "Use Bracket?",
        required: true,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "matchRegions",
        label: "Match Regions",
        required: false,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "matchRegionRounds",
        label: "Region Rounds",
        required: false,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "startingTime",
        label: "Starting Time",
        required: true,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "teeTimeGap",
        label: "Gap (min)",
        required: true,
        block: 1,
        blockName: "Tee Sheet Properties",
        locked: false,
    },
    {
        section: "Round Details",
        field: "targetRoundLength",
        label: "Target Length (hrs)",
        required: true,
        block: 0,
        blockName: "The Round",
        locked: false,
    },
    {
        section: "Round Details",
        field: "type",
        label: "Type",
        required: true,
        block: 2,
        blockName: "Handicap Usage",
    },
    {
        section: "Round Details",
        field: "indReduction",
        label: "Reduction %",
        required: true,
        block: 2,
        blockName: "Handicap Usage",
    },
    {
        section: "Round Details",
        field: "compositeType",
        label: "Method",
        required: true,
        block: 2,
        blockName: "Handicap Usage",
    },
    {
        section: "Round Details",
        field: "compositeBuild",
        label: "Composite",
        required: true,
        block: 2,
        blockName: "Handicap Usage",
    },
] satisfies RoundDataLayout;
